import './ngn-account-banner.scss';

import bannerBg from '@basqet-dashboard/common/assets/images/naira-banner-bg.png';
import PropTypes from 'prop-types';
import React from 'react';

const NgnAccountBanner = ({ onCtaClick }) => (
  <section
    className="ngn-account-banner"
    style={{ backgroundImage: `url(${bannerBg})` }}
    aria-label="Get a dedicated Naira account">
    <div className="ngn-account-banner__content">
      <h3 className="ngn-account-banner__title">Get a Dedicated Naira Account</h3>
      <p className="ngn-account-banner__subtitle">
        Receive instant NGN payments and manage transactions in one place
      </p>
      <button type="button" className="ngn-account-banner__cta" onClick={onCtaClick}>
        Get Account Details <span aria-hidden="true">&rarr;</span>
      </button>
    </div>
  </section>
);

NgnAccountBanner.propTypes = {
  onCtaClick: PropTypes.func.isRequired
};

export { NgnAccountBanner };
